// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Container_wrapper__10O88","view_size_wide":"Container_view_size_wide__2mEVX","view_disableGutters":"Container_view_disableGutters__hbxE9"};